import { render, staticRenderFns } from "./AvailabilitiesAgenda.vue?vue&type=template&id=18107e2e&scoped=true&"
import script from "./AvailabilitiesAgenda.vue?vue&type=script&lang=ts&"
export * from "./AvailabilitiesAgenda.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18107e2e",
  null
  
)

export default component.exports